<template>
  <div class="goods-manage">
    <el-card>
      <div slot="header" class="card-header">
        <span>商品管理（idle_goods）</span>
        <div>
          <el-button type="warning" size="small" @click="handleRebuildGeo">重建GEO索引</el-button>
        </div>
      </div>

      <el-form :inline="true" :model="query" class="filter-form">
        <el-form-item label="标题">
          <el-input v-model="query.titleLike" placeholder="按标题模糊" clearable size="small" />
        </el-form-item>
        <el-form-item label="openid">
          <el-input v-model="query.openid" placeholder="输入用户openid" clearable size="small" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="fetchList(1)">查询</el-button>
          <el-button size="small" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" min-width="120" />
        <el-table-column prop="title" label="标题" min-width="160" />
        <el-table-column prop="price" label="价格" width="100" />
        <el-table-column prop="community" label="小区" min-width="140" />
        <el-table-column prop="dealway" label="交易方式" width="100">
          <template slot-scope="scope">
            {{ dealwayText(scope.row.dealway) }}
          </template>
        </el-table-column>
        <el-table-column prop="category" label="分类" width="100">
          <template slot-scope="scope">
            {{ categoryText(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status)" size="small">
              {{ statusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="is_featured" label="精选商品" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_featured ? 'success' : 'info'" size="small">
              {{ scope.row.is_featured ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="view_count" label="浏览数" width="100" />
        <el-table-column prop="created_at" label="创建时间" min-width="160" />
        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">详情</el-button>
            <el-button
              v-if="scope.row.status !== 2"
              type="text"
              size="small"
              @click="handleToggleStatus(scope.row)"
            >
              {{ scope.row.status === 1 ? '下架' : '上架' }}
            </el-button>
            <el-button v-else type="text" size="small" disabled>已售出</el-button>
            <el-button
              type="text"
              size="small"
              :style="{ color: scope.row.is_featured ? '#f56c6c' : '#409eff' }"
              @click="handleToggleFeatured(scope.row)"
            >
              {{ scope.row.is_featured ? '取消精选' : '设为精选' }}
            </el-button>
            <el-button type="text" size="small" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :page-size="limit"
          :current-page.sync="page"
          :total="total"
          @current-change="fetchList"
        />
      </div>
    </el-card>

    <el-dialog :title="'商品详情'" :visible.sync="detailVisible" width="700px">
      <el-descriptions v-if="current" :column="2" size="small" border>
        <el-descriptions-item label="ID">{{ current.id }}</el-descriptions-item>
        <el-descriptions-item label="openid">{{ current.openid }}</el-descriptions-item>
        <el-descriptions-item label="标题">{{ current.title }}</el-descriptions-item>
        <el-descriptions-item label="价格">{{ current.price }}</el-descriptions-item>
        <el-descriptions-item label="小区">{{ current.community }}</el-descriptions-item>
        <el-descriptions-item label="街道">{{ current.street }}</el-descriptions-item>
        <el-descriptions-item label="交易方式">{{ dealwayText(current.dealway) }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ statusText(current.status) }}</el-descriptions-item>
        <el-descriptions-item label="分类">{{ categoryText(current) }}</el-descriptions-item>
        <el-descriptions-item label="精选商品">
          <el-tag :type="current.is_featured ? 'success' : 'info'" size="small">
            {{ current.is_featured ? '是' : '否' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="浏览数">{{ current.view_count }}</el-descriptions-item>
        <el-descriptions-item label="距离(米)">{{ current.distance }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ current.created_at }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ current.updated_at }}</el-descriptions-item>
        <el-descriptions-item label="简介" :span="2">{{ current.briefintro }}</el-descriptions-item>
        <el-descriptions-item label="联系方式" :span="2">{{ current.contact }}</el-descriptions-item>
      </el-descriptions>
      <div style="margin-top: 12px" v-if="images && images.length">
        <el-image
          v-for="img in images"
          :key="img.id"
          :src="img.image_url"
          style="width: 120px; height: 90px; margin-right: 8px"
          fit="cover"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/utils/http'

function toViewGoods (g) {
  return {
    id: g.id,
    openid: g.openid,
    title: g.title,
    price: g.price,
    community: g.community,
    street: g.street,
    dealway: g.dealway,
    latitude: g.latitude,
    longitude: g.longitude,
    status: g.status,
    briefintro: g.briefintro,
    contact: g.contact,
    view_count: g.viewCount,
    distance: g.distance,
    created_at: g.createdAt,
    updated_at: g.updatedAt,
    category: g.category,
    is_idle: g.isIdle,
    is_housekeeping: g.isHousekeeping,
    is_training: g.isTraining,
    is_featured: g.isFeatured
  }
}

function toViewImage (img) {
  return {
    id: img.id,
    image_url: img.imageUrl,
    order_index: img.orderIndex,
    created_at: img.createdAt
  }
}

 

export default {
  name: 'GoodsManage',
  data () {
    return {
      loading: false,
      list: [],
      page: 1,
      limit: 10,
      total: 0,
      hasMore: false,
      query: {
        titleLike: '',
        openid: ''
      },
      detailVisible: false,
      current: null,
      images: []
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    statusText (s) {
      return s === 1 ? '上架' : (s === 0 ? '下架' : (s === 2 ? '已售出' : '未知'))
    },
    statusTagType (s) {
      return s === 1 ? 'success' : (s === 0 ? 'info' : (s === 2 ? 'warning' : ''))
    },
    dealwayText (d) {
      return d === 'help-self' ? '自提' : (d === 'mail' ? '邮寄' : (d || ''))
    },
    categoryText (g) {
      const c = g.category
      if (c === 'idle') return '闲置物品'
      if (c === 'housekeeping') return '家政服务'
      if (c === 'training') return '培训服务'
      if (c === 'information') return '资讯分类'
      if (c === 'food') return '美食分类'
      if (g.is_idle === 1) return '闲置物品'
      if (g.is_housekeeping === 1) return '家政服务'
      if (g.is_training === 1) return '培训服务'
      return c || '未知'
    },
    async fetchList (page = this.page) {
      this.page = page
      this.loading = true
      try {
        const params = {
          page: this.page,
          limit: this.limit,
          titleLike: this.query.titleLike || undefined,
          openid: this.query.openid || undefined
        }
        // 只有填写了 openid 时才传递 type: 'myidle'
        if (this.query.openid) {
          params.type = 'myidle'
        }
        const res = await http.get('/api/idle-goods/list', { params })
        let items = []
        let total = 0
        let hasMore = false
        if (res && typeof res === 'object') {
          const data = Array.isArray(res.data) ? res.data : []
          items = data
          total = res.total != null ? res.total : data.length
          hasMore = !!res.hasMore
        }
        this.list = items.map(toViewGoods)
        this.total = total
        this.hasMore = hasMore
      } catch (e) {
        this.$message.error(e.message || '获取商品列表失败')
      } finally {
        this.loading = false
      }
    },
    resetQuery () {
      this.query.titleLike = ''
      this.query.openid = ''
      this.fetchList(1)
    },
    async handleView (row) {
      try {
        const data = await http.get(`/api/idle-goods/${row.id}`)
        const goods = toViewGoods(data)
        this.current = goods
        this.images = Array.isArray(data.images) ? data.images.map(toViewImage) : []
        this.detailVisible = true
      } catch (e) {
        this.$message.error(e.message || '获取商品详情失败')
      }
    },
    async handleToggleStatus (row) {
      if (row.status === 2) {
        this.$message.info('已售出不可变更状态')
        return
      }
      const target = row.status === 1 ? 0 : 1
      try {
        await http.post('/api/idle-goods/status', {
          id: row.id,
          status: target,
          openid: row.openid
        })
        row.status = target
        const idx = this.list.findIndex(g => g.id === row.id)
        if (idx !== -1) {
          this.$set(this.list, idx, { ...this.list[idx], status: target })
        }
        this.$message.success('状态更新成功')
      } catch (e) {
        this.$message.error(e.message || '状态更新失败')
      }
    },
    async handleRebuildGeo () {
      try {
        await this.$confirm('确认重建所有商品的地理索引吗？', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      try {
        await http.post('/api/idle-goods/rebuild-geo')
        this.$message.success('重建 GEO 索引任务已完成')
      } catch (e) {
        this.$message.error(e.message || '重建失败')
      }
    },
    async handleToggleFeatured (row) {
      const targetFeatured = !row.is_featured
      const action = targetFeatured ? '设为精选' : '取消精选'
      try {
        await http.post('/api/idle-goods/featured', {
          id: row.id,
          openid: row.openid,
          featured: targetFeatured
        })
        row.is_featured = targetFeatured
        const idx = this.list.findIndex(g => g.id === row.id)
        if (idx !== -1) {
          this.$set(this.list, idx, { ...this.list[idx], is_featured: targetFeatured })
        }
        this.$message.success(`${action}成功`)
      } catch (e) {
        this.$message.error(e.message || `${action}失败`)
      }
    },
    async handleDelete (row) {
      try {
        await this.$confirm(`确认删除商品（ID: ${row.id}）吗？`, '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      try {
        await http.delete(`/api/idle-goods/${row.id}`, { params: { openid: row.openid } })
        this.$message.success('删除成功')
        this.fetchList(this.page)
      } catch (e) {
        this.$message.error(e.message || '删除失败')
      }
    }
  }
}
</script>

<style scoped>
.goods-manage {
  min-height: 300px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-form {
  margin-bottom: 10px;
}

.pager {
  margin-top: 16px;
  text-align: right;
}
</style>
